<template>
  <div>
    <div class="search-bar">
      <div class="search-bar__container">
        <a
          href="//www.polskieradio.pl"
          target="_blank"
          tabindex="0"
          aria-label="Polskie Radio Logo"
        >
          <div class="search-bar__logo"></div>
        </a>
        <div class="search-bar__icons">
          <div
            class="search-bar__search-icon"
            v-on:click.stop="toggleSearch"
            v-on:keyup.enter="toggleSearch"
            tabindex="0"
            aria-label="Pokaż pasek wyszukiwania"
          ></div>
          <div
            class="search-bar__login-icon"
            :class="{ searchBarIsLogged: isLogged, showTooltip }"
            @click="editProfile"
            @mouseover="hover = true"
            @mouseleave="hover = false"
            v-on:keyup.enter="editProfile"
            tabindex="0"
            aria-label="Opcje"
          >
            <span v-if="hover && !isLogged" class="login__tooltip">Zaloguj / załóż konto</span>
            <img src="@/assets/login2.png" alt="Log in" />
            <span v-if="isLogged" class="search-bar__login-username">{{ shortUsername }}</span>
            <transition name="fade">
              <div class="search-bar__tooltip" v-if="showTooltip">
                <div class="search-bar__tooltip-top" style="fontFamily:'Poppins'">
                  <div class="search-bar__tooltip-img">
                    <img src="@/assets/login2.png" alt="Log in" />
                  </div>
                  <div class="search-bar__tooltip-userdata">
                    <h2>{{ username }}</h2>
                    <p>{{ email }}</p>
                  </div>
                </div>
                <hr />
               
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <SearchDropdown v-on-clickaway="this.onClickAway" />
  </div>
</template>

<script>
import SearchDropdown from "../../SearchDropdown/Desktop/SearchDropdown";
import { mixin as clickaway } from "vue-clickaway";
import mixin from "../mixin";

export default {
  mixins: [mixin, clickaway],
  components: {
    SearchDropdown
  }
};
</script>

<style scoped lang="scss">
.search-bar {
  height: 2.8125rem;
  background-color: rgba(25, 30, 42, 0.4);
  &__container {
    width: 100%;
    height: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s ease-out;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  &__logo {
    width: 9rem;
    height: 2rem;
    background-image: url("/img/logoPRSA.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    cursor: pointer;
  }
  &__icons {
    height: 100%;
    display: flex;
    align-items: center;
  }
  &__search-icon {
    width: 2rem;
    height: 2rem;
    background-image: url("/icons/search.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    cursor: pointer;
  }
  &__login-icon {
    width: 3.8rem;
    height: 100%;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    background: #5f2651;
    margin-left: 1.5rem;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    display: flex;
    &.searchBarIsLogged {
      padding-left: 1rem;
    }
    &:hover {
      background-color: #af2f82;
      background-image: -webkit-gradient(
        linear,
        left top,
        right top,
        from(#df2860),
        to(#af2f82)
      );
      background-image: linear-gradient(to right, #df2860, #af2f82);
    }
    img {
      margin: 0 auto;
    }
    &::after {
      content: "";
      width: 20px;
      height: 20px;
      background-color: transparent;
      position: absolute;
      top: calc(100% + 0.35rem);
      left: 1.5rem;
      transition: 0.35s;
      pointer-events: none;
      opacity: 0;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid white;
    }
    & span {
      transition: 0.35s;
    }
    &.showTooltip span {
      color: rgba(255, 255, 255, 0.5);
    }
    &.showTooltip::after {
      opacity: 1;
    }
    &:focus {
      outline: none;
    }
  }
  &__tooltip {
    min-width: 15rem;
    height: auto;
    background: white;
    position: absolute;
    top: calc(100% + 1rem);
    right: 0;
    border-radius: 6px;
    color: #0f1626;
    z-index: 1;
    cursor: default;

    &-top {
      display: flex;
      padding: 1rem;
      justify-content: flex-start;
      padding-bottom: 0;
      img {
        filter: invert(100%);
        margin-right: 1rem;
      }
    }
    &-userdata {
      display: flex;
      flex-direction: column;
      justify-content: center;
      line-height: 1.4;
      color: #0f1626;
      h2 {
        font-weight: bold;
      }
      p {
        font-size: 0.8rem;
      }
    }
    hr {
      border: 1px solid #efeeee;
      border-bottom: none;
    }
    &-bottom {
      padding: 1rem;
      padding-top: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      li {
        cursor: pointer;
        font-size: 0.8rem;
        line-height: 1.5rem;
        &:hover {
          color: #5c4ec4;
        }
      }
    }
  }
  .searchBarIsLogged {
    width: auto;
    background: rgb(222, 41, 94);
    background: linear-gradient(
      125deg,
      rgba(222, 41, 94, 1) 0%,
      rgba(60, 37, 65, 1) 100%
    );
    font-family: "Poppins", sans-serif;
    color: white;
    span {
      margin: 0 1rem;
      margin-right: 2rem;
    }
  }
}
.login__tooltip {
  position: absolute;
  left: 3.7rem;
  width: max-content;
  background-color: rgba(255, 255, 255, 0.65);
  padding: 5px;
  border-radius: 3px;
  font-family: "Poppins", sans-serif;
  color: #2c253f;
  font-weight: 500;
  font-size: 0.8rem;
  -webkit-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);

  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    left: -6px;
    right: auto;
    top: 25%;
    border-style: solid;
    border-width: 5px 6px 5px 0;
    border-color: transparent rgba(255, 255, 255, 0.65) transparent transparent;
  }

  @media (max-width: 1470px) {
    right: 3.7rem;
    left: auto;
    -webkit-box-shadow: -3px 3px 5px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: -3px 3px 5px 0px rgba(0, 0, 0, 0.75);
    box-shadow: -3px 3px 5px 0px rgba(0, 0, 0, 0.75);
    &::after {
      content: "";
      border-width: 5px 0 5px 6px;
      border-style: solid;
      border-width: 5px 0 5px 6px;
      border-color: transparent transparent transparent
        rgba(255, 255, 255, 0.65);
      left: auto;
      right: -6px;
    }
  }
}
</style>
